import React from 'react';
import { Button } from './ui/Button';
import { Download, Lock, Star } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-transparent text-[#3A3A3A] px-4 text-center" data-id="element-242">
      <div className="max-w-4xl mx-auto" data-id="element-243">
        <div className="mb-12" data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-[#3A3A3A]" data-id="element-245">
            Recupera el control hoy.
          </h2>
          <p className="text-xl text-[#7A7A7A] font-light" data-id="element-246">
            No necesitas "ser otra persona". Necesitas un protocolo que tu
            cuerpo entienda.
          </p>
        </div>

        <div className="bg-white border border-[#E8E8E6] rounded-3xl p-8 md:p-12 relative overflow-hidden shadow-sm" data-id="element-247">
          <div className="relative z-10" data-id="element-248">
            <div className="flex flex-col lg:flex-row items-center gap-10 mb-10 border-b border-[#E8E8E6] pb-10" data-id="element-249">
              {/* Product Image */}
              <a href="https://pay.hotmart.com/D104310882V?bid=1770407336992" target="_blank" rel="noopener noreferrer" className="shrink-0 relative group" data-id="element-250">
                <img src="https://cdn.magicpatterns.com/uploads/w6xCwDnec1XDHdyMMWNapW/Ansiedad_expres_optimized.png" alt="Ansiedad Exprés Cover" className="relative w-48 rounded-lg shadow-lg rotate-[-2deg] group-hover:rotate-0 transition-transform duration-300 border border-[#E8E8E6] cursor-pointer" data-id="element-251" />
              </a>

              <div className="flex-1 w-full" data-id="element-252">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6" data-id="element-253">
                  <div className="text-center md:text-left" data-id="element-254">
                    <h3 className="text-2xl font-semibold text-[#3A3A3A] mb-2" data-id="element-255">
                      Ansiedad Exprés
                    </h3>
                    <p className="text-[#7A7A7A]" data-id="element-256">Ebook Digital</p>
                  </div>
                  <div className="text-center md:text-right" data-id="element-257">
                    <div className="flex items-baseline justify-center md:justify-end gap-2" data-id="element-258">
                      <span className="text-4xl font-bold text-[#3A3A3A] tracking-tight" data-id="element-259">
                        $111.99
                      </span>
                      <span className="text-lg font-medium text-[#7A7A7A]" data-id="element-260">
                        MXN
                      </span>
                    </div>
                    <p className="text-xs text-[#7A7A7A] mt-1" data-id="element-261">Pago único</p>
                  </div>
                </div>

                <a href="https://pay.hotmart.com/D104310882V?bid=1770407336992" target="_blank" rel="noopener noreferrer" className="w-full" data-id="element-262">
                  <Button size="lg" className="w-full text-lg py-5" withIcon data-id="element-263">
                    Quiero el protocolo
                  </Button>
                </a>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-[#7A7A7A]" data-id="element-264">
              <span className="flex items-center gap-1.5" data-id="element-265">
                <Lock className="w-4 h-4" data-id="element-266" /> Pago seguro
              </span>
              <span className="hidden sm:inline text-[#E8E8E6]" data-id="element-267">•</span>
              <span className="flex items-center gap-1.5" data-id="element-268">
                <Download className="w-4 h-4" data-id="element-269" /> Entrega inmediata
              </span>
              <span className="hidden sm:inline text-[#E8E8E6]" data-id="element-270">•</span>
              <span className="flex items-center gap-1.5" data-id="element-271">
                <Star className="w-4 h-4 text-[#5BBFB5]" data-id="element-272" /> 4.9/5 Calificación
              </span>
            </div>
          </div>
        </div>

        <p className="mt-12 text-sm text-[#7A7A7A] max-w-xl mx-auto font-light" data-id="element-273">
          Este producto no sustituye la terapia profesional. Si experimentas
          síntomas severos o crónicos, por favor consulta a un especialista de
          salud mental.
        </p>
      </div>
    </section>;
}